import { tourStep } from './tourRegistry';

export const bandaActuacionesSteps = [
  tourStep(
    'actuaciones-prereq',
    'Antes de crear',
    'Hace falta al menos un músico y una formación. Completa eso en Gestión y aquí podrás pasar lista, refuerzos y repertorio.',
  ),
  tourStep(
    'actuaciones-header',
    'Actuaciones',
    'Conciertos, procesiones y demás. Pasa lista, comparte la encuesta de asistencia y asigna formación y repertorio.',
  ),
  tourStep(
    'actuaciones-nueva',
    'Nueva actuación',
    'Fecha, lugar y tipo. Luego abres la ficha para asistencia y partituras.',
  ),
  tourStep(
    'actuaciones-tabs',
    'En curso e histórico',
    'Las de fecha futura (o sin fecha) están <strong>en curso</strong>. Las pasadas van al <strong>histórico</strong> (consulta).',
  ),
];
